var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    fillRule: "evenodd",
    d: "M20.707 2.292c.135.135 3.293 3.4 3.293 12.707a1 1 0 0 1-1 1h-2v6h-2v-19a1 1 0 0 1 1.707-.707zM21 13.999h.987c-.079-2.949-.5-5.157-.987-6.757v6.757zm-13-8c0 1.858-1.28 3.41-3 3.858v12.142H3V9.857c-1.72-.448-3-2-3-3.858v-4h2v4c0 .738.405 1.375 1 1.723V1.999h2v5.723c.595-.348 1-.986 1-1.723v-4h2v4zm4 3c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6zm0 10c2.206 0 4-1.794 4-4 0-2.205-1.794-4-4-4s-4 1.795-4 4c0 2.206 1.794 4 4 4zm1.5-6a1.5 1.5 0 0 1 1.5 1.5c0 1.5-3 3.5-3 3.5s-3-2-3-3.5a1.5 1.5 0 0 1 3 0 1.5 1.5 0 0 1 1.5-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/breakfast.2c1165dc726b2e8327e3cde0d3b02ee3.svg";
export { ForwardRef as ReactComponent };